// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconBrandShazam, IconHelp, IconSitemap, IconBrandTailwind } from '@tabler/icons';

// constant
const icons = {
    IconHelp,
    IconSitemap,
    IconBrandShazam,
    IconBrandTailwind
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        {
            id: 'sample-page',
            title: <FormattedMessage id="sample-page" />,
            type: 'item',
            url: '/sample-page',
            icon: icons.IconBrandShazam,
            breadcrumbs: false
        },
        {
            id: 'record-volunteer-hours',
            title: <FormattedMessage id="record-volunteer-hours" />,
            type: 'item',
            url: '/record-volunteer-hours',
            icon: icons.IconBrandTailwind,
            breadcrumbs: false
        },
        {
            id: 'documentation',
            title: <FormattedMessage id="documentation" />,
            type: 'item',
            url: 'https://codedthemes.gitbook.io/berry/',
            icon: icons.IconHelp,
            external: true,
            target: true
        },
        {
            id: 'roadmap',
            title: <FormattedMessage id="roadmap" />,
            type: 'item',
            url: 'https://codedthemes.gitbook.io/berry/roadmap',
            icon: icons.IconSitemap,
            external: true,
            target: true
        }
    ]
};

export default other;
